module.exports = __webpack_public_path__ + "static/img/3.8c20202.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/eng/3.png
// module id = F9TX
// module chunks = 0